var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTessaOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5fc90d",
    fillRule: "evenodd",
    d: "M3.742 14.002C4.878 14.667 6.137 15 7.5 15s2.622-.333 3.758-.998a7.55 7.55 0 0 0 2.728-2.73A7.24 7.24 0 0 0 15 7.509c0-1.366-.333-2.626-1.014-3.764a7.3 7.3 0 0 0-2.728-2.73C10.122.332 8.863 0 7.5 0S4.878.332 3.742 1.015a7.3 7.3 0 0 0-2.728 2.73C.333 4.883 0 6.143 0 7.51c0 1.365.333 2.607 1.014 3.763a7.55 7.55 0 0 0 2.728 2.73zM2.64 7.246l.891-.875a.6.6 0 0 1 .438-.193c.175 0 .315.07.437.193l2.203 2.205 3.986-3.973a.6.6 0 0 1 .437-.193c.174 0 .314.07.437.193l.891.875a.58.58 0 0 1 .175.437.6.6 0 0 1-.175.456l-5.297 5.286a.63.63 0 0 1-.454.192.63.63 0 0 1-.437-.192L2.64 8.139a.62.62 0 0 1-.175-.456c0-.174.053-.332.175-.437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTessaOnline);
export default __webpack_public_path__ + "static/media/tessa-online.1c2e422edba1f4a64fb2c4ea142ba824.svg";
export { ForwardRef as ReactComponent };